import { customDateRanges, getDateObject } from "app/popleads/app/functions/util";
import { TooltipOverlay } from "app/popleads/components/TooltipOverlay";
import CustomDrawer, { DrawerBody, DrawerContent, DrawerHeader } from "app/popleads/components/drawer/CustomDrawer";
import useDisclosure from "app/popleads/hooks/useDisclosure";
import IndustryFilter from "app/popleads/modules/filters/components/IndustryFilter";
import TypeFilter from "app/popleads/modules/filters/components/TypeFilter";
import React from "react";
import { DateRangePicker } from "react-date-range";
import { useDispatch, useSelector } from "react-redux";
import styles from "../../../popleads/assets/css/design_3.0/CustomDatePicker.module.scss";
import { actions } from "app/popleads/modules/accounts/redux/accountsRedux";
import ButtonWithText from "app/popleads/components/ui-kit/Button";

const AccountFilterDrawer = ({ isForAccountDetail = false }) => {
    const { isOpen, onClose, onToggle } = useDisclosure();

    const { selectedDate } = useSelector((state) => state.accounts);
    const dispatch = useDispatch();

    return (
        <>
            <TooltipOverlay placement="bottom" tooltip="Filters">
                <ButtonWithText
                    label="Open filters"
                    icon={"filter"}
                    buttonStyle="selectedOption"
                    variant="primary"
                    onClick={onToggle}
                />
            </TooltipOverlay>

            <CustomDrawer position="right" size="md" open={isOpen} onClose={onClose}>
                <DrawerContent>
                    <DrawerHeader onClose={onClose} sx={{ border: "none" }}>
                        Filters
                    </DrawerHeader>
                    <DrawerBody>
                        {!isForAccountDetail && (
                            <>
                                <div className="secondary-color font-weight-bold mb-2">Filter by Industry</div>
                                <IndustryFilter />
                                <div className="secondary-color font-weight-bold mt-4 mb-2">Filter by Type</div>
                                <TypeFilter />
                            </>
                        )}
                        <div className="secondary-color font-weight-bold mt-4 mb-2">Filter by Date</div>
                        <DateRangePicker
                            className={styles.rdrDateRangePickerWrapper}
                            ranges={[selectedDate]}
                            staticRanges={customDateRanges(new Date(null), new Date())}
                            onChange={(item) => {
                                let date = getDateObject(item.selection);
                                if (date.dateString === "Invalid date - Invalid date") {
                                    date = { ...date, predefinedTag: "allTime", dateString: "All Time" };
                                }
                                dispatch(actions.setSelectedDate(date));
                                // DOM manipulation to highlight "All Time"
                                const range = document.querySelector(".rdrStaticRanges")?.firstElementChild;
                                if (range && !item.selection.startDate) {
                                    range.classList.add("rdrStaticRangeSelected");
                                } else {
                                    range.classList.remove("rdrStaticRangeSelected");
                                }
                            }}
                            inputRanges={[]}
                            direction="vertical"
                        />
                    </DrawerBody>
                </DrawerContent>
            </CustomDrawer>
        </>
    );
};

export default AccountFilterDrawer;
